export default "__VITE_ASSET__859cd41e__"